import { t } from "@lingui/core/macro";
import { LanguageCode } from "src/utils/localization/languages/types";
import { legacyUrl } from "src/utils/routing/legacyUrl";
import { SitePageContext } from "types/graphql-types";
import { StickyMenuSectionRef } from "components/StickyMenu/StickyMenu";
import { isPresent } from "src/utils/checks";

export function getParentPath(
  pageContext: SitePageContext
): string | undefined {
  const parentPaths = pageContext.parentPaths;
  const languageCode = pageContext.languageCode as LanguageCode;
  if (parentPaths && languageCode)
    return legacyUrl(parentPaths[languageCode]?.path);

  return undefined;
}

export const buildMenuSections = ({
  hasExcursions,
  withOnboard,
  withEvents,
  withShip,
  withPrePost,
  withStories,
  withBrochure
}): StickyMenuSectionRef[] => {
  return [
    { title: t`Fares`, id: "fares", trackingName: "fares" },
    {
      title: hasExcursions ? t`Itinerary & Excursions` : t`Itinerary`,
      id: "itinerary",
      trackingName: "itinerary"
    },
    withOnboard
      ? {
          title: t`Onboard`,
          id: "onboard",
          trackingName: "onboard"
        }
      : undefined,
    withEvents
      ? {
          title: t`cruise-events-section-title`,
          id: "events",
          trackingName: "events"
        }
      : undefined,
    { title: t`Benefits`, id: "benefits", trackingName: "benefits" },
    withShip
      ? {
          title: t`Ship`,
          id: "ship",
          trackingName: "ship"
        }
      : undefined,
    { title: t`Suites`, id: "suites", trackingName: "suites" },
    withPrePost
      ? {
          title: t`Pre-post hotels`,
          id: "prePost",
          trackingName: "pre-post-hotels"
        }
      : undefined,
    withStories
      ? {
          title: t`Stories`,
          id: "stories",
          trackingName: "blog"
        }
      : undefined,
    withBrochure
      ? {
          title: t`Brochure`,
          id: "brochure",
          trackingName: "brochure"
        }
      : undefined
  ].filter(isPresent);
};
